'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchEntityIfNeeded;

var _effects = require('redux-saga/effects');

var _fetchEntity = require('./fetchEntity');

var _fetchEntity2 = _interopRequireDefault(_fetchEntity);

var _entityKey = require('./entityKey');

var _entityKey2 = _interopRequireDefault(_entityKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchEntityIfNeeded].map(_regenerator2.default.mark);

function fetchEntityIfNeeded(entity) {
  var args = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var fetchOptions = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
  var key, loaded;
  return _regenerator2.default.wrap(function fetchEntityIfNeeded$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          key = (0, _entityKey2.default)(fetchOptions.key, entity, args);
          _context.next = 3;
          return (0, _effects.select)(entity.loaded, key);

        case 3:
          loaded = _context.sent;

          if (!loaded) {
            _context.next = 8;
            break;
          }

          _context.next = 7;
          return (0, _effects.select)(entity.data, key);

        case 7:
          return _context.abrupt('return', _context.sent);

        case 8:
          _context.next = 10;
          return (0, _effects.call)(_fetchEntity2.default, entity, args, fetchOptions);

        case 10:
          return _context.abrupt('return', _context.sent);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}